export enum JobApiUrls {
  GetJobs = '/api/Job/GetJobs',
  GetPlanJobs = '/api/Job/GetPlanJobs',
  GetHDPlanJobs = '/api/Job/GetHDPlanJobs',
  GetPlanRules = '/api/PlanRule/GetPlanRules',
  CreateJob = '/api/Job/CreateJob',
  EditJob = '/api/Job/EditJob',
  DeleteJob = '/api/Job/DeleteJob',
  GetJobDetails = '/api/Job/GetJobDetails',
  OptimizeJob = '/api/Job/OptimizeJob',
  CalculateJobETA = '/api/Job/CalculateJobETA',
  PrintJob = '/api/Plan/PrintJob',
  InjectLocationInJobs = '/api/Job/InjectLocationInJobs',
  BatchInjectLocationInJobs = '/api/Job/BatchInjectLocationInJobs',
  GetJobTemplateLookUp = '/api/JobTemplate/GetJobTemplateLookUp',
  JobTerminalsAndLocationsCheck = '/api/Job/JobTerminalsAndLocationsCheck',
  JobNewTerminalsAndLocationsCheck = '/api/Job/JobNewTerminalsAndLocationsCheck',
  CalculateHDPlanJobETA = '/api/Job/CalculateCompleteHDJob',
  GetHDSequence = '/api/Job/GetHDSequence',
  UpdateHdJob = '/api/Job/UpdateHDJob',
}
